import { useContractorBadgePictureUpload } from "@src/appV2/Agents/api/useContractorBadgePictureUpload";
import { createIndependentContractorBadgePdf } from "@src/appV2/Agents/components/ContractorBadge/utils/createBadgePdf";
import { useToast } from "@src/appV2/lib";
import { base64ToBlob } from "@src/appV2/lib/files/utils";
import { useMutation } from "@tanstack/react-query";

import { sharePdf } from "./utils";

export function useSaveBadge() {
  // To upload the badge picture to the backend when user clicks on the save badge button
  const { showSuccessToast } = useToast();
  const { mutateAsync: uploadContractorBadgePicture } = useContractorBadgePictureUpload({
    onSuccess: () => {
      showSuccessToast(
        "Badge creation successful. Please download and print this badge for any future shifts that may require it"
      );
    },
  });

  return useMutation({
    mutationFn: async (params: {
      pictureFileBase64: string;
      workerId: string;
      firstName: string;
      lastName: string;
      qualification: string;
      licenseNumber: string;
    }) => {
      const {
        pictureFileBase64: fileBase64,
        workerId,
        firstName,
        lastName,
        qualification,
        licenseNumber,
      } = params;

      // Generate A4 PDF with 1.5mm margin for saving
      const badgePdf = await createIndependentContractorBadgePdf({
        details: {
          firstName,
          lastName,
          qualification,
          licenseNumber,
          profilePictureBase64: fileBase64,
        },
        sizeOptions: {
          size: "A4" as const,
          margin: 1.5,
        },
      });

      const file = await base64ToBlob(fileBase64);

      await uploadContractorBadgePicture({
        file,
        workerId,
      });

      await sharePdf({
        pdfBlob: badgePdf.blob,
        workerId,
        qualification,
        firstName,
        lastName,
        licenseNumber,
      });
    },
  });
}
